import { render } from "./splash.vue?vue&type=template&id=4b7ac50c&scoped=true"
import script from "./splash.vue?vue&type=script&lang=js"
export * from "./splash.vue?vue&type=script&lang=js"

import "./splash.vue?vue&type=style&index=0&id=4b7ac50c&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7ac50c"]])

export default __exports__